<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { onMount } from "svelte";
  import moneyFormatters from "@shared/filters/money.js";
  import Flash from "@shared/services/flashv2.js";
  import { pluralize } from "@shared/svelte/Modules/pluralize";

  export let linkHref = null;
  export let startDate;
  export let endDate;

  type Product = {
    name: string;
    distributor_name: string;
    case_quantity: number;
    container_counts: {
      bottle: number;
      can: number;
      keg: number;
      other: number;
      box: number;
    };
    spend: number;
  };
  let reportsOverviewProducts: Array<Product> = [];

  const fetchReportsOverviewProducts = async () => {
    try {
      reportsOverviewProducts = await HttpPromise({
        method: "GET",
        url: "/api/retailer/reports/overview_products",
        data: { start_date: startDate, end_date: endDate },
      });
    } catch (error) {
      Flash.now({
        message: "There was an error while fetching reports overview. Please contact support",
        type: "error",
      });
    }
  };

  onMount(() => {
    (async () => {
      await fetchReportsOverviewProducts();
    })();
  });

  const productQuantity = (product: Product) => {
    const returnedString = [];

    const usedContainers = Object.keys(product.container_counts).filter(container => {
      return product.container_counts[container] > 0;
    });

    usedContainers.forEach(container => {
      returnedString.push(
        `${product.container_counts[container]} ${pluralize(
          container,
          product.container_counts[container]
        )}`
      );
    });

    const casesQty = product.case_quantity;
    if (casesQty > 0) returnedString.push(`${casesQty} ${pluralize("case", casesQty)}`);

    return returnedString.join(", ");
  };

</script>

<style>
  .icon-padding {
    padding-top: 0.2rem;
  }

</style>

<div
  class="fizz-card fizz-card-interactive fizz-flex-item fizz-inset-squish-16 reports-overview-products"
>
  <!-- svelte-ignore a11y-missing-content -->
  <a href={linkHref} class="fizz-overlay-link" />
  <div class="fizz-space-between fizz-stack-12">
    <h4 class="fizz-heading-4">Top Products</h4>
    <div class="fizz-align-self-start icon-padding">
      <Icon type="ArrowRight" />
    </div>
  </div>
  <table class="fizz-table-compact">
    <colgroup>
      <col style="width: 15rem;" />
      <col style="width: 15rem;" />
      <col style="width: 15rem;" />
      <col />
    </colgroup>
    <tr>
      <th class="fizz-text-subdued">PRODUCT</th>
      <th class="fizz-text-subdued">DISTRIBUTOR</th>
      <th class="fizz-text-subdued">QTY</th>
      <th class="fizz-text-subdued fizz-text-right">*SPEND</th>
    </tr>
    {#each reportsOverviewProducts as product}
      <tr>
        <td>{product.name}</td>
        <td>{product.distributor_name}</td>
        <td>{productQuantity(product)}</td>
        <td class="fizz-text-positive fizz-text-right"
          >{moneyFormatters.filter5()(product.spend)}</td
        >
      </tr>
    {/each}
  </table>
</div>
